export default () => ({
  componentName: 'cell-filled',
});
